var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20vmin",
    height: "20vmin",
    fill: "orange",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.75 14a.75.75 0 00-1.5 0v3.326H9.33a.75.75 0 00-.665 1.345L9 18l-.335.671.002.001.003.001.006.003.017.009.053.024c.044.018.103.043.178.071.15.057.366.128.644.198.558.139 1.369.272 2.432.272s1.874-.133 2.432-.272c.278-.07.493-.141.644-.198a3.617 3.617 0 00.23-.095l.018-.009.007-.003.002-.001h.001c.001-.001.001-.001-.334-.672l.335.67a.75.75 0 00-.665-1.344h-1.92V14zm-1.5 3.326H9.33a4.49 4.49 0 00.602.196c.314.079.754.16 1.318.202v-.398zm1.5.398v-.398h1.92a4.5 4.5 0 01-.602.196c-.314.079-.754.16-1.318.202z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.75A7.25 7.25 0 004.75 10c0 2.587 1.98 4.745 3.439 5.966.902.754 1.561 1.878 1.561 3.146 0 1.18.957 2.138 2.138 2.138h.239c1.172 0 2.123-.95 2.123-2.123 0-1.28.673-2.409 1.584-3.162C17.287 14.762 19.25 12.63 19.25 10A7.25 7.25 0 0012 2.75zM3.25 10a8.75 8.75 0 0117.5 0c0 3.35-2.45 5.871-3.96 7.12-.644.534-1.04 1.267-1.04 2.007a3.623 3.623 0 01-3.623 3.623h-.24a3.638 3.638 0 01-3.637-3.638c0-.736-.388-1.464-1.023-1.996C5.723 15.858 3.25 13.31 3.25 10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.c39badc5.svg";
export { ForwardRef as ReactComponent };